import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#f8f9fa',
  padding: theme.spacing(6, 0),
  marginTop: theme.spacing(8),
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

const SocialButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

function Footer() {
  return (
    <FooterContainer>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="primary" gutterBottom>
              JobsPortal
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Find your dream job with our comprehensive job search platform.
              Connect with top companies and opportunities.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="subtitle1" gutterBottom>
              For Job Seekers
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <FooterLink href="/jobs">Browse Jobs</FooterLink>
              <FooterLink href="/companies">Companies</FooterLink>
              <FooterLink href="/career-advice">Career Advice</FooterLink>
              <FooterLink href="/resume-builder">Resume Builder</FooterLink>
            </Box>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="subtitle1" gutterBottom>
              For Employers
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <FooterLink href="/post-job">Post a Job</FooterLink>
              <FooterLink href="/pricing">Pricing</FooterLink>
              <FooterLink href="/recruitment">Recruitment</FooterLink>
              <FooterLink href="/employer-resources">Resources</FooterLink>
            </Box>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="subtitle1" gutterBottom>
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <FooterLink href="/about">About Us</FooterLink>
              <FooterLink href="/contact">Contact</FooterLink>
              <FooterLink href="/blog">Blog</FooterLink>
              <FooterLink href="/careers">Careers</FooterLink>
            </Box>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="subtitle1" gutterBottom>
              Legal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <FooterLink href="/privacy">Privacy Policy</FooterLink>
              <FooterLink href="/terms">Terms of Service</FooterLink>
              <FooterLink href="/cookies">Cookie Policy</FooterLink>
            </Box>
          </Grid>
        </Grid>
        <Divider sx={{ my: 4 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} JobsPortal. All rights reserved.
          </Typography>
          <Box>
            <SocialButton aria-label="Facebook">
              <FacebookIcon />
            </SocialButton>
            <SocialButton aria-label="Twitter">
              <TwitterIcon />
            </SocialButton>
            <SocialButton aria-label="LinkedIn">
              <LinkedInIcon />
            </SocialButton>
            <SocialButton aria-label="Instagram">
              <InstagramIcon />
            </SocialButton>
          </Box>
        </Box>
      </Container>
    </FooterContainer>
  );
}

export default Footer; 